import React from 'react';
import { Typography } from '@material-ui/core';
import { env } from '@/config';

const Version = () => (
  <Typography variant="body2" color="textSecondary" align="center">
    {`Versión ${env.APP_VERSION}`}
  </Typography>
);

export default Version;
